import { PaymentService } from '../../../services/payment-service/payment.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { loadStripe, StripeCardElement } from '@stripe/stripe-js';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
})
export class PaymentComponent /*implements OnInit*/ {
  stripe: any;
  card: StripeCardElement | null = null;
  packType : string;
  stripePromise = loadStripe('pk_test_51R22CFFS8kUFVqJj4cE66DnsTM1xsCqvOPSU1mOCpySLeQRospuLJUmpPl1B0RZgtsYyOEdMJiwBC3BTvFWaqm5Y00OA1aOX3Z');

  constructor(private paymentService: PaymentService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.packType  = data.packType;
  }

  /*
  async ngOnInit() {
    this.stripe = await loadStripe('pk_test_51R22CFFS8kUFVqJj4cE66DnsTM1xsCqvOPSU1mOCpySLeQRospuLJUmpPl1B0RZgtsYyOEdMJiwBC3BTvFWaqm5Y00OA1aOX3Z'); // Remplace par ta clé publique Stripe
    const elements = this.stripe.elements();

    // Créer un élément de carte
    this.card = elements.create('card');
    this.card.mount('#card-element'); // Assurez-vous d'avoir un div avec cet ID dans votre template
  }
    */

  async checkout(packType: string) {
    const stripe = await this.stripePromise;
    const { token, error } = await this.stripe.createToken(this.card);
    this.paymentService.createCheckoutSession({ packType: this.packType }).subscribe(async session => {
      if (stripe) {
        await stripe.redirectToCheckout({ sessionId: session.id });
      }
    });
  }

  async pay() {
    if (!this.card) {
      console.error('Stripe card element is not loaded');
      return;
    }

    const { token, error } = await this.stripe.createToken(this.card);

    if (error) {
      console.error(error);
      return;
    }

    this.paymentService.charge({ token: token.id, packType: this.packType }).subscribe(
      response => {
        if (response.status === 'success') {
          // Afficher un message à l'utilisateur
          alert(`Paiement réussi : ${response.charge.amount / 100} ${response.charge.currency.toUpperCase()}`);
        } else {
            console.error('Échec du paiement');
        }
        // Gérer le succès du paiement
      },
      error => {
        console.error('Payment error:', error);
        // Gérer l'erreur de paiement
      }
    );
  }
}
